module.exports = __webpack_public_path__ + "img/no-hatchery.93b4d5d0.svg";